import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import { Tabs, Card, Flex } from '@percent/lemonade'
import { TabPanel } from '@percent/admin-dashboard/common/components'
import { QuestionsContainer } from './questions/QuestionsContainer'
import { FormsListContainer } from './formsList/FormsListContainer'

const FORMS_ROUTE = '/grants-forms/forms'
const QUESTIONS_ROUTE = '/grants-forms/questions'

export function GrantsFormsContainer() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const [activeTab, setActiveTab] = useState(location.pathname)

  useEffect(() => {
    if (location.pathname === '/grants-forms') {
      navigate(QUESTIONS_ROUTE, { replace: true })
    } else {
      setActiveTab(location.pathname)
    }
  }, [location.pathname, navigate])

  const handleTabChange = (newValue: string) => {
    setActiveTab(newValue)
    navigate(newValue)
  }

  const tabItems = [
    { key: FORMS_ROUTE, label: t('grants.forms.tabs.forms') },
    { key: QUESTIONS_ROUTE, label: t('grants.forms.tabs.questions') }
  ]

  return (
    <Card>
      <Flex direction="column" w="100%">
        <Flex direction="column" px="lg" pt="lg">
          <Tabs activeTab={activeTab} onChangeTab={handleTabChange} items={tabItems} />
        </Flex>
        <TabPanel value={activeTab} index={FORMS_ROUTE}>
          <FormsListContainer />
        </TabPanel>
        <TabPanel value={activeTab} index={QUESTIONS_ROUTE}>
          <QuestionsContainer />
        </TabPanel>
      </Flex>
    </Card>
  )
}
